import format from 'date-fns/format';
import { v4 as uuid } from 'uuid';
import { INVOICE_TYPES } from '../../../../../config/invoice/constants';
import { getInvoiceTypeTransaction } from '../../../../../helpers/invoiceHelpers';

export const defaultItemData = () => {
  return {
    descriptionAr: '',
    descriptionEn: '',
    description: '',
    unitPrice: '',
    quantity: '',
    discountAmount: '',
    discountPercentage: '',
    vatRateType: '',
    vatRate: '',
    netAmount: '',
    vatAmount: '',
    totalAmount: '',
    creating: true,
  };
};

export const getValueOrString = (obj, key) => obj?.[key] || '';

export const getSampleCreateInvoiceInitialValues = ({
  user,
  invoiceReferenceNumber,
  type,
  language,
  category,
  countryCode,
}) => ({
  documentType: type,
  documentTransactionType: category,
  paidAmount: 0,
  invoiceIssueDate: '2025-11-18',
  invoiceTypeDescription: 'Tax Invoice',
  invoiceTypeTransaction: '0100000',
  noteType:
    type === 'credit'
      ? 'CREDIT_NOTE'
      : type === 'debit'
      ? 'DEBIT_NOTE'
      : 'CREDIT_NOTE',
  invoiceReferenceNumber: '',
  tempItem: {
    id: 'f0676272-18b7-4616-a53c-5c94ee2cb58b',
    descriptionAr: '',
    descriptionEn: '',
    description: '',
    unitPrice: '',
    quantity: '',
    discountAmount: '',
    discountPercentage: '',
    vatRateType: '5',
    vatRate: '',
    netAmount: '',
    vatAmount: '',
    totalAmount: '',
    creating: true,
  },
  items: [
    {
      id: '2e599d74-1270-4851-ba3c-109331007657',
      descriptionAr: '',
      descriptionEn: 'Apple',
      unitPrice: '12',
      quantity: '12.000',
      discountAmount: '0.000',
      discountPercentage: '0.000',
      vatRateType: '5',
      vatRate: '5',
      netAmount: '144.000',
      vatAmount: '7.200',
      totalAmount: '151.200',
      creating: true,
      subtotalAmount: '144.000',
    },
  ],
  notesAr: '',
  notesEn: '',
  supplyStartDate: '',
  supplyEndDate: '',
  purchaseOrderNumber: '',
  contactNumber: '',
  specialTaxTreatmentEn: '',
  specialTaxTreatmentAr: '',
  originalInvoiceReference: '',
  originalGrossAmount: '',
  noteReasonOfIssuance: '',
  precedingInvoiceNumber: '',
  precedingInvoiceIssueDate: '',
  noteIssuingReason: '',
  paymentTerms: {
    paymentMethod: 'CASH',
    bankNameEn: '',
    bankNameAr: '',
    accountNumber: '',
    paymentTermsAr: '',
    paymentTermsEn: '',
  },
  invoiceDiscountLineItems: [],
  invoicePrepaymentLineItems: [],
  invoicingPeriodStartDate: '18/11/2025',
  invoicingPeriodEndDate: '19/11/2025',
  sellerEnglishName: 'Mohammad',
  vatNumber: '220007019800002',
  sellerVatNumber: '220007019800002',
  groupVatNumber: '220007019800002',
  additionalSellerIdType: 'OTH',
  additionalSellerId: '1010123456',
  sellerBuildingNumber: '2',
  additionalSellerBuildingNumber: '12',
  sellerNeighborhoodEn: 'Al Olaya',
  sellerStreetEn: 'King Fahd Road',
  sellerCity: 'MANAMA',
  buyerEnglishName: 'Desert Horizons LLC',
  buyerVatNumber: '302345678900003',
  additionalBuyerIdType: 'NATIONAL_ID',
  additionalBuyerId: '123',
  buyerBuildingNumber: '123',
  additionalBuyerBuildingNumber: '123',
  buyerBlock: '123',
  buyerStreetEn: '123',
  buyerCity: 'MUHARRAQ',
  paymentMethod: 'CASH',
  paymentTermsEn: '123',
  supplyDate: '18/11/2025',
  invoiceStatus: 'ACCEPTED',
});

export const getCreateInvoiceInitialValues = ({
  user,
  invoiceReferenceNumber,
  type,
  language,
  category,
  countryCode,
  ...rest
}) =>
  //{ ...defaultStandardForm });
  ({
    vatNumber: getValueOrString(user, 'tax_number'),
    documentType: type,
    documentTransactionType: category,
    invoiceIssueDate: format(new Date(), 'yyyy-MM-dd'),
    invoiceTypeDescription: INVOICE_TYPES[category][language],
    invoiceTypeTransaction: getInvoiceTypeTransaction({
      invoiceType: category,
    }),
    paidAmount: 0,
    noteType:
      type === 'credit'
        ? 'CREDIT_NOTE'
        : type === 'debit'
        ? 'DEBIT_NOTE'
        : 'CREDIT_NOTE',
    invoiceReferenceNumber,
    sellerVatNumber: getValueOrString(user, 'tax_number'),

    groupVatNumber: getValueOrString(user, 'groupVatNumber'),
    sellerEnglishName: getValueOrString(user, 'name'),
    sellerArabicName: getValueOrString(user, 'sellerArabicName'),
    additionalSellerIdType: 'SUBCRN',
    additionalSellerId: getValueOrString(user, 'additionalSellerId'),
    sellerStreetEn: getValueOrString(user, 'sellerStateEn'),
    sellerStreetAr: getValueOrString(user, 'sellerStateAr'),
    additionalSellerStreetEn: getValueOrString(
      user,
      'additionalSellerStreetEn',
    ),
    additionalSellerStreetAr: getValueOrString(
      user,
      'additionalSellerStreetAr',
    ),
    sellerBuildingNumber: getValueOrString(user, 'sellerBuildingNumber'),
    additionalSellerBuildingNumber: getValueOrString(
      user,
      'additionalSellerBuildingNumber',
    ),
    sellerCity: getValueOrString(user, 'sellerCity'),
    sellerPostalCode: getValueOrString(user, 'sellerPostalCode'),
    sellerStateEn: getValueOrString(user, 'sellerStateEn'),
    sellerStateAr: getValueOrString(user, 'sellerStateAr'),
    sellerNeighborhoodEn: getValueOrString(user, 'sellerNeighborhoodEn'),
    sellerNeighborhoodAr: getValueOrString(user, 'sellerNeighborhoodAr'),
    sellerCountryCode: countryCode,

    buyerEnglishName: '',
    buyerArabicName: '',
    buyerVatNumber: '',
    buyerGroupVatNumber: '',
    additionalBuyerIdType: '',
    additionalBuyerId: '',
    buyerStreetEn: '',
    buyerStreetAr: '',
    additionalBuyerStreetEn: '',
    additionalBuyerStreetAr: '',
    buyerBuildingNumber: '',
    additionalBuyerBuildingNumber: '',
    buyerCity: '',
    buyerPostalCode: '',
    buyerStateEn: '',
    buyerStateAr: '',
    buyerBlock: '',
    buyerNeighborhoodAr: '',
    buyerCountryCode: countryCode,

    tempItem: {
      id: uuid(),
      ...defaultItemData(),
    },
    items: [],
    notesAr: '',
    notesEn: '',
    supplyStartDate: '',
    supplyEndDate: '',
    purchaseOrderNumber: '',
    contactNumber: '',
    specialTaxTreatmentEn: '',
    specialTaxTreatmentAr: '',
    originalInvoiceReference: '',
    originalGrossAmount: '',
    noteReasonOfIssuance: '',
    precedingInvoiceNumber: '',
    precedingInvoiceIssueDate: '',
    noteIssuingReason: '',
    paymentTerms: {
      paymentMethod: 'CASH',
      bankNameEn: '',
      bankNameAr: '',
      accountNumber: '',
      paymentTermsAr: '',
      paymentTermsEn: '',
    },
    invoiceDiscountLineItems: [],
    invoicePrepaymentLineItems: [],
    invoicingPeriodStartDate: '',
    invoicingPeriodEndDate: '',
    invoiceStatus: 'IN_DRAFT',
    currency: 'BHD',
    ...rest,
  });

export const getDiscountFormInitialValues = (items) => ({
  items: items || [],
  tempItem: {
    type: 'amount',
    discountAmount: '',
    amountSubjectToDiscount: '',
    rate: '',
    discountVatRateType: '',
    taxExemptionReason: null,
  },
});

export const getPaymentFormInitialValues = (lineItems) => ({
  lineItems: lineItems || [],
  tempLineItem: {
    invoiceNumber: '',
    invoiceIssueDate: '',
    taxableAmount: '',
    vatRate: '',
  },
});
